<template>
<div>
  <div class="title-bar title-h3">{{selectTitle}}</div>
  <hr class="mr-b20" />
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h4">감시 디렉토리</div>
      <div class="setting-addel mr-l15">
        <el-button size="mini" @click="addDetectDirectory"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!isDeleted" @click="deleteDetectDirectory"><i class="fas fa-minus"></i></el-button>
      </div>
    </div>
    <div>
      <el-button :disabled="!isDeleted" size="small" type="primary" @click="saveGroup">그룹저장</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper ref="detectTable" row-class-name="c-dblclick" :data="dataList" :columns="fileDetectColumns" :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote pagination
    @selection-change="detectChangeSelection" :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="editBulkFileList" style="width:100%;">
  </el-table-wrapper>
  <w-bulk-detect-popup ref="bulkDetectPopup" :selectPhysicalNode="selectPhysicalNode" @reload-data="loadData" :popup-type="detectPopupType" :editRow="editRow"></w-bulk-detect-popup>
  <w-bulk-create-group-save-popup ref="bulkCreateGroupSavePopup" :changeCheckList="detectChangeList" @reload-data="loadData"></w-bulk-create-group-save-popup>
</div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WBulkDetectPopup from '@/views/settings/server/FileDetectSettings/BulkFileCreateView/popup/BulkDetectPopup';
import WBulkCreateGroupSavePopup from '@/views/settings/server/FileDetectSettings/BulkFileCreateView/popup/BulkCreateGroupSavePopup';

export default {
  name: 'WDetectListView',
  components: {
    WBulkDetectPopup,
    WBulkCreateGroupSavePopup,
  },
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      total: null,
      columnDefault,
      detectPopupType: null,
      selectTitle: '',
      isDeleted: false,
      dataList: null,
      showSearchTool: false,
      serverId: null,
      editRow: {},
      detectChangeList: [],
      fileDetectColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'path',
          label: '디렉토리 명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'detectFileSize',
          label: '감시 크기 설정 (MB)',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        // 선택한 트리의 타입이 노드인 경우에만 데이터를 호출하도록 설정
        if (!isNil(this.selectPhysicalNode) && this.selectPhysicalNode.type === 'obj') {
          this.serverId = this.selectPhysicalNode.serverId;
          this.selectTitle = `[${this.selectPhysicalNode.label}] 대용량 파일 생성 감시`;
          this.loadData();
        }
      },
      immediate: true,
    },
    detectChangeList: {
      handler() {
        if (this.detectChangeList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      this.$nextTick(() => {
        const tableParams = this.$refs.detectTable.getParameter();
        const params = {
          serverId: this.serverId,
          ...tableParams,
        };
        ServerSettingAPI.getBulkFileDetectList(params).then((response) => {
          if (response.data.success) {
            this.total = response.data.total;
            this.dataList = response.data.data;
          }
        });
      });
    },
    /**
     * [addDetectDirectory 서버 설정> 대용량 파일 생성 감시 목록의 항목을 추가할 수 있는 팝업을 띄운다.]
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    addDetectDirectory() {
      this.editRow = {};
      this.detectPopupType = 'ADD';
      this.$refs.bulkDetectPopup.open();
    },
    /**
     * [editBulkFileList 서버 설정> 대용량 파일 생성 감시 목록의 항목을 수정할 수 있는 팝업을 띄운다.]
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    editBulkFileList(row) {
      this.editRow = cloneDeep(row);
      this.detectPopupType = 'EDIT';
      this.$refs.bulkDetectPopup.open();
    },
    /**
     * [editBulkFileList 서버 설정> 대용량 파일 생성 감시 목록에서 선택한 항목ㅇ을 삭제한다.]
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    deleteDetectDirectory() {
      const target = '감시 디렉토리';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        ServerSettingAPI.deleteBulkFileDetectDir(this.detectChangeList).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [detectChangeSelection 서버 설정> 대용량 파일 생성 감시 목록의 체크 항목을 추가한다.]
     * @author yelim
     * @param  {[type]} selectVal [description]
     * @return {[type]}           [description]
     */
    detectChangeSelection(selectVal) {
      this.detectChangeList = selectVal;
    },
    onChangeTable() {
      this.loadData();
    },
    saveGroup() {
      this.$refs.bulkCreateGroupSavePopup.open();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/FileDetectSettings/BulkFileCreateView/component/DetectListView.vue